export const NOMEFERMATA_START = 'NOMEFERMATA_START'